export const COMPUTE_RESOURCE_LIST_POLL_INTERVAL_MS = 30_000;
